module.exports = __webpack_public_path__ + "img/feedbackMystery.05adb6db.svg";